module.exports = __webpack_public_path__ + "ag.no1.dc1f16f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ag.no1.jpg
// module id = ew46
// module chunks = 0